import React from 'react';

const ITDocsContext = React.createContext('itDocs');

export const ITDocsListContextProvider = ITDocsContext.Provider;

export default ITDocsContext;
